<div class="text-center widget-title pt-4">Sales/Week Last 30 days.</div>
<chart-main-sales
  [chartData]="chartData"
  *ngIf="chartData && chartData.data.length>0"></chart-main-sales>
<widget-nochart-data
  *ngIf="chartData && chartData.data.length==0"></widget-nochart-data>
